import { render, staticRenderFns } from "./MisMensajes.vue?vue&type=template&id=fdad57ee&"
import script from "./MisMensajes.vue?vue&type=script&lang=js&"
export * from "./MisMensajes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports